import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon, { iconNames } from '../common/icon';
import { COLORS } from '../../constants';
import { trackEvent } from '../../utils/common/analytics';
import { SocialFollowModal } from '../common/modals/SocialFollowModal';

const PLACEMENT = 'search_feed_end';

const TEXTS = {
    ge: {
        title: 'გამოიწერეთ worldauto.ge',
        body: 'ახალი მანქანები, ფასები და ავტო სიახლეები — Telegram-სა და Facebook-ზე.',
    },
    ru: {
        title: 'Подпишитесь на нас',
        body: 'Новые машины, цены и автоновости — в Telegram и Facebook.',
    },
    en: {
        title: 'Follow us',
        body: 'New cars, prices and car news — on Telegram and Facebook.',
    },
    ua: {
        title: 'Підпишіться на нас',
        body: 'Нові авто, ціни та автоновини — у Telegram і Facebook.',
    },
};

const SocialFollowCard = () => {
    const { t, i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const text = TEXTS[i18n.language] || TEXTS.en;

    const handleOpen = () => {
        trackEvent('social_follow_open', { placement: PLACEMENT });
        setIsOpen(true);
    };

    return (
        <>
            <button type="button" className="social-card" onClick={handleOpen}>
                <div className="social-card__head">
                    <div className="social-card__icons">
                        <Icon name={iconNames.facebook} size={36} />
                        <div className="social-card__telegram">
                            <Icon
                                name={iconNames.telegram}
                                size={20}
                                fill={COLORS.WHITE}
                            />
                        </div>
                    </div>
                    <div className="social-card__title">{text.title}</div>
                </div>
                <div className="social-card__body">{text.body}</div>
                <div className="social-card__btn">{t('tgPublishNudgeBtn')}</div>
            </button>
            <SocialFollowModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                placement={PLACEMENT}
            />
        </>
    );
};

export default SocialFollowCard;
